module.exports = __webpack_public_path__ + "static/media/32_A.4cfd3111.png";